import { createSelector } from '@reduxjs/toolkit';
import { ExpiryMethod } from 'client/voladeum/expiry-methods/types';
import { RootState } from 'store';

const expiryMethodsSlice = (state: RootState) => state.expiry_methods;

export const selectExpiryMethods = createSelector(
  [expiryMethodsSlice],
  (state): ExpiryMethod[] => state
);
